import { IEnvironment } from "src/app/services/environment.interface";

export const environment: IEnvironment = {
  production: false,
  apiBaseUrl: 'https://as-account-v2-p-14e9577abb4c.herokuapp.com/',
  defaultAppUrl: 'https://dev-clinic.healthexam.com/app-redirect',
  remitAppUrl: 'https://wa-remit-v2-d-f32c1665b95c.herokuapp.com',
  adminAppUrl: 'https://dev-admin.healthexam.com',
  phiAppUrl: 'https://dev-patients.healthexam.com',
  studiesAppUrl: 'https://dev-studies.healthexam.com',
  billerAppUrl: 'https://dev-biller.healthexam.com',
  engageAppUrl: 'https://dev-engage.healthexam.com',
  chartsAppUrl: 'https://dev-charts-v2.healthexam.com/',
  clinicAppUrl: 'https://dev-clinic.healthexam.com',
  healthpayAppUrl: 'https://id-preview--4cbbc3f9-d56c-46ff-bdb9-a4b05c022dfa.lovable.app/',
  automateAppUrl:
    'https://id-preview--81eec655-e426-455e-a23a-0ff80984e7c4.lovable.app/',
  custodianAppUrl:
    'https://id-preview--88d8aad4-82d0-4bc1-a2a3-9c50a3d50199.lovable.app/',
  threadsAppUrl: 'https://id-preview--d8f36b74-92af-4ea3-986f-5982b3d1c6b8.lovable.app/',
  chartsV2AppUrl: 'https://dev-charts-v2.healthexam.com',
  signatureAppUrl: 'https://dev-sign-v2.healthexam.com',
  betaAppUrl: 'https://beta.healthexam.com',
  signatureKey: 'heathexamplatform@lo!@0oa8zj*4j8y=tx*6t$ytx-4=nqne8pbi8_tiv9l(8jaf(',
  defaultSignupOrganizationId: '27a8906a-a8ab-415f-9128-029901816a91',
  ayaAppUrl: 'https://id-preview--ad5b0495-bbf4-49ca-8dce-8544734ccca6.lovable.app/',
  ayaHealthChatAppUrl: 'https://dev-www.healthexam.com/',
  googleOAuthClientId:
    '572116536248-78p9lhof5cn70r504e9c1ofm2ok235hu.apps.googleusercontent.com',
  entraEmailOtpViaBff: false,
  emailOtpIdp: 'google' as const,
  googleEmailOtpDelivery: 'twilio_verify' as const,
  firebase: {
    apiKey: 'AIzaSyDN1pXIrSxKQXqljdWz-E7AXqocxgMYmvE',
    authDomain: 'dev-auth.healthexam.ai',
    projectId: 'health-exam-ai-apps',
    storageBucket: 'health-exam-ai-apps.firebasestorage.app',
    messagingSenderId: '381040570177',
    appId: '1:381040570177:web:2c92caa037452eef183bc0',
  },
  googleBrowserLogoutOnSignOut: true,
};
